import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { SectionRow } from "./SectionRow";
import { Indentation } from "./rowTypes";
import { useCallback } from "react";
import { useDrawerStack } from "shared-ui";
import { StackedIntegrationCenterTransferIntegrationDrawer } from "@features/orders-features/components/order-drawer/StackedIntegrationCenterTransferIntegrationDrawer";
import { CombinedWarehouseOrderItemDto } from "@lib/ShiOneClient";
import { INTEGRATION_TRANSFER_DRAWER_SEGMENT } from "../../orderDrawerSegments";
import { toIntegrationTransferRouteId } from "../../integrationTransferRouteId";

type Props = Indentation & {
  lineNumber?: number;
  warehouseOrderLineItems: CombinedWarehouseOrderItemDto[] | undefined;
};

export function ProductPickTickets({
  lineNumber,
  warehouseOrderLineItems,
  xWidth,
  xGap,
}: Props) {
  const { pushDrawer } = useDrawerStack();

  const handlePickTicketClick = useCallback(
    (ticketNumber: string): void => {
      if (!warehouseOrderLineItems?.length) return;
      const pickTicket = warehouseOrderLineItems.find(
        (p) => p.uniqueIdentifier === ticketNumber,
      );
      if (!pickTicket) return;
      const routeId = toIntegrationTransferRouteId(pickTicket);
      pushDrawer({
        id: `integration-transfer-${ticketNumber}`,
        component: StackedIntegrationCenterTransferIntegrationDrawer,
        props: {
          details: pickTicket,
        },
        ...(routeId && {
          route: { segment: INTEGRATION_TRANSFER_DRAWER_SEGMENT, id: routeId },
        }),
      });
    },
    [warehouseOrderLineItems, pushDrawer],
  );

  if (!lineNumber || !warehouseOrderLineItems?.length) {
    return null;
  }

  return (
    <>
      <SectionRow xWidth={xWidth} xGap={xGap}>
        <Alert severity="info">
          <Typography variant="body2" color="textPrimary" gutterBottom>
            This item is being worked on in our Integration Center. Check back
            soon for updates.
          </Typography>
          <Stack spacing={0}>
            {warehouseOrderLineItems.map((p) => (
              <Box
                key={p.uniqueIdentifier}
                sx={{ display: "flex", gap: 0.5, alignItems: "baseline" }}
              >
                <Button
                  size="small"
                  variant="text"
                  onClick={() =>
                    p.uniqueIdentifier &&
                    handlePickTicketClick(p.uniqueIdentifier)
                  }
                  sx={{
                    textTransform: "none",
                    justifyContent: "flex-start",
                    fontSize: "body2.fontSize",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  • {p.uniqueIdentifier}
                </Button>
                {p.orderItemQty && (
                  <Typography variant="body2" color="textSecondary">
                    (Qty {p.orderItemQty})
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </Alert>
      </SectionRow>
    </>
  );
}
